package org.example.project.enginefinanzen

import androidx.compose.runtime.*
import kotlinx.coroutines.launch
import org.example.project.enginetabular.TabularScreen
import org.example.project.enginetabular.TabularSplitScreen
import org.example.project.screens_sys.EingangsbelegeApi
import org.example.project.utils.All

private val monatsHeaders = listOf("Monat", "Belege", "Positionen", "Brutto", "MwSt.", "Netto")
private val monatsbelegHeaders = listOf("Belegdatum", "Belegnummer", "Händler", "Positionen", "Brutto", "MwSt.", "Netto")
private val monatsnamen = listOf("Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember")

private fun monatsname(key: String): String {
    val teile = key.split("-")
    val monat = teile.getOrNull(1)?.toIntOrNull()?.takeIf { it in 1..12 } ?: return key
    return "${monatsnamen[monat - 1]} ${teile.firstOrNull().orEmpty()}"
}

@Composable
fun SysEingangsrechnungenScreen() {
    val scope = rememberCoroutineScope()
    var monate by remember { mutableStateOf(emptyList<All>()) }
    var belege by remember { mutableStateOf(emptyList<All>()) }
    var selectedMonth by remember { mutableStateOf<String?>(null) }

    suspend fun reload() {
        monate = EingangsbelegeApi.loadMonate()
        val preferred = selectedMonth?.takeIf { id -> monate.any { it.id == id } }
            ?: monate.firstOrNull()?.id
        selectedMonth = preferred
        belege = preferred?.let { EingangsbelegeApi.loadMonatsbelege(it) }.orEmpty()
    }

    LaunchedEffect(Unit) { reload() }
    LaunchedEffect(selectedMonth) {
        belege = selectedMonth?.let { EingangsbelegeApi.loadMonatsbelege(it) }.orEmpty()
    }

    TabularSplitScreen(
        initialRatio = 0.42f,
        minRatio = 0.25f,
        maxRatio = 0.65f,
        screen1 = {
            TabularScreen(
                screenKey = "EingangsrechnungenMonate",
                rollenKey = "Eingangsrechnungen",
                title = "Eingangsrechnungen – Monate",
                headers = monatsHeaders,
                data = monate.map { row ->
                    row.id to listOf(
                        monatsname(row.monat.ifBlank { row.id }),
                        row.belegAnzahl.toString(), row.positionAnzahl.toString(),
                        row.brutto, row.mwst, row.netto
                    )
                },
                editable = false,
                includeMetadata = false,
                onCommit = {},
                onRowClick = { selectedMonth = it },
                onSelectedRowsChange = { rows -> rows.singleOrNull()?.let { selectedMonth = it } },
                onRefresh = { scope.launch { reload() } }
            )
        },
        screen2 = {
            TabularScreen(
                screenKey = "EingangsrechnungenMonatsbelege",
                entityScope = selectedMonth.orEmpty(),
                rollenKey = "Eingangsrechnungen",
                title = selectedMonth?.let { "Belege – ${monatsname(it)}" } ?: "Belege des Monats",
                headers = monatsbelegHeaders,
                data = belege.map { row ->
                    row.id to listOf(
                        row.belegdatum, row.belegnummer, row.haendler, row.positionAnzahl.toString(),
                        row.brutto, row.mwst, row.netto
                    )
                },
                editable = false,
                includeMetadata = false,
                onCommit = {},
                onRefresh = { scope.launch { reload() } }
            )
        }
    )
}
